<mat-form-field appearance="outline" class="w-100">
  <mat-label class="pb-2">{{ productName }} <span class="text-danger">*</span></mat-label>
  <input matInput type="text" class="form-control p-0" [formControl]="formControlRef"
         [attr.disabled]="(productType === 6 && edit) ? true: false">
  <mat-error *ngIf="fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName]">
    {{ fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName] }}
  </mat-error>
</mat-form-field>
